export const SET_DATE = (state, payload = []) => {
    // console.log(state);
    // state.section.items = payload;
};